import pathify from 'vuex-pathify'
export default pathify

pathify.options.mapping = 'simple'
pathify.options.deep = 2
